/**
 * A foto da pessoa, ou as iniciais quando não há foto — ou quando ela não
 * carrega (061).
 *
 * O link da foto é assinado e vence em cinco minutos. Uma tela aberta há mais
 * tempo que isso tenta de novo ao redesenhar e recebe 404: em vez da imagem
 * quebrada, volta às iniciais até a próxima leitura trazer um link novo.
 */

import { useState, type ReactNode } from 'react';
import { iniciaisDe } from '../avatar/avatar';
import './foto-ou-iniciais.css';

export function FotoOuIniciais({
  nome,
  foto,
  tamanho,
  classe = 'foto-ou-iniciais',
}: {
  nome: string;
  foto: string | null;
  tamanho: number;
  classe?: string;
}): ReactNode {
  const [falhou, definirFalhou] = useState<string | null>(null);
  const mostrarFoto = foto !== null && falhou !== foto;

  return (
    <span className={classe} style={{ width: tamanho, height: tamanho }} aria-hidden="true">
      {mostrarFoto ? (
        <img src={foto} alt="" onError={() => definirFalhou(foto)} />
      ) : (
        iniciaisDe(nome)
      )}
    </span>
  );
}
